export var printWithCss = function printWithCss(cssClass) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rootElement = document.querySelector('html');
  if (!rootElement || !cssClass) {
    return setTimeoutPromise(timeout).then(function () {
      return window.print();
    });
  }
  rootElement.classList.add(cssClass);
  return setTimeoutPromise(timeout).then(function () {
    window.print();
    rootElement.classList.remove(cssClass);
  });
};
var setTimeoutPromise = function setTimeoutPromise(delay) {
  return new Promise(function (resolve, reject) {
    try {
      setTimeout(function () {
        resolve();
      }, delay);
    } catch (e) {
      reject(e);
    }
  });
};
export var ensureImagesLoaded = function ensureImagesLoaded() {
  return new Promise(function (resolve) {
    setTimeoutPromise(0).then(function () {
      Promise.all(Array.from(document.images).filter(function (img) {
        return !img.complete;
      }).map(function (img) {
        return new Promise(function (resolve) {
          img.addEventListener('load', resolve);
          img.addEventListener('error', resolve);
        });
      })).then(function (result) {
        resolve(result);
      });
    });
  });
};